import styled, { keyframes } from 'styled-components';

const spinnerAnimation = keyframes`
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
`;

const StyledSpinnerSpan = styled.span<{ color?: string }>`
	position: absolute;
	height: 40%;
	aspect-ratio: 1;
	border-radius: 50%;
	border-top: 3px solid ${({ color }) => color ?? 'white'};
	border-right: 3px solid transparent;
	animation: ${spinnerAnimation} 1s linear infinite;
	transition: border-color 0.25s ease;
`;

const StyledSpinnerContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export { StyledSpinnerSpan, StyledSpinnerContainer };
